import { FlexContainer, Text } from '@taxdown/piccolo-web';
import useScreen from 'Hooks/useScreen';
import FormContainer from 'Components/UI/FormContainer';
import ContentContainer from 'Components/UI/ContentContainer';
import { ScreenPropsType } from 'Types/common';
import HelpInfo from '../HelpInfo';
import ValidationSubmit from '../ValidationSubmit';
import DynamicForm from '../DynamicForm';
import Heading from '../Heading';
import * as Styled from '../../styles';

const ChildScreen = ({ screenName }: ScreenPropsType): JSX.Element => {
  const { screen, onNextScreen, onPrevScreen, renderForm, yayoyakis, onReloadYayos } =
    useScreen(screenName);

  const { header, subheader, help } = renderForm;
  return (
    <ContentContainer testID="child-section">
      <Styled.Container direction="column" fullWidth fullHeight gap="dimension_16">
        <FormContainer>
          <FlexContainer direction="column" gap="dimension_32">
            <Heading title={header} />
            {subheader && (
              <Text color="grey" size="S_M_S">
                {subheader}
              </Text>
            )}
            <FlexContainer direction="column" gap="dimension_16">
              <DynamicForm yayoyakis={yayoyakis} onReloadYayos={onReloadYayos} />
            </FlexContainer>
          </FlexContainer>
        </FormContainer>
        {help && <HelpInfo info={help} />}
        <ValidationSubmit
          testID="btnSubmit"
          disabled={!screen.isDataValid()}
          onNextScreen={onNextScreen}
          onPrevScreen={onPrevScreen}
          isTrackForm
          screen={screen}
          data={yayoyakis}
        />
      </Styled.Container>
    </ContentContainer>
  );
};

export default ChildScreen;
